import { render, staticRenderFns } from "./jak-inwestowac-w-srebro.md?vue&type=template&id=2e0a4498&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports